// CameraSearch.ts
import { HttpParams }   from '@angular/common/http';
import { FormControl } from '@angular/forms';

export default class AuditSearch {
    id                        : Number = null;

    date_from                 : FormControl    = new FormControl();
    date_from_timestamp       : Number         = null;
    date_to                   : FormControl    = new FormControl();
    date_to_timestamp         : Number         = null;

    probe                     : String         = null;
    operation_type            : String         = null;

    operation_result          : String         = null;        
    operation_result_choices  : Object[]       = [
                                                  { "name" : "generic.all" , "value" : null },
                                                  { "name" : "generic.success" , "value" : 1 },
                                                  { "name" : "generic.error" , "value" : 0 }
                                                 ]

    constructor()
    {
    }

    getHttpParams()
    {
      var params = new HttpParams({});
      if (this.id               !== null) { params = params.set('id', this.id.toString()); }

      // if (this.date_from.value          !== null) { params = params.set('date_from',            this.date_from.toString()); }
      // if (this.date_to.value            !== null) { params = params.set('date_to',              this.date_to.toString()); }
      if (this.date_from.value            !== null) { params = params.set('date_from_timestamp', (new Date(this.date_from.value).getTime() / 1000).toString()); }
      if (this.date_to.value              !== null) { params = params.set('date_to_timestamp',   (new Date(this.date_to.value).getTime() / 1000).toString()); }
      if (this.probe                      !== null) { params = params.set('probe',                this.probe.toString()); }
      if (this.operation_type             !== null) { params = params.set('operation_type',       this.operation_type.toString()); }

      if (this.operation_result           !== null) { params = params.set('operation_result',     this.operation_result.toString()); }
      
      return params;
    }

  }